import { useParams } from 'react-router-dom'

// End
import { ReportCreatePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

// Required import for CI compliance :/
import CollectionsBootstrap from 'modules/ai_reports/lib/CollectionsBootstrap'
import { useSlugToSourceId } from 'modules/ai_reports/lib/useSlugToSourceId'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AiReportsMainContent } from './components/ReportCreatePage'

typeof (<CollectionsBootstrap />)

const AiReportsPage = () => {
  const { slug } = useParams()
  const { company } = useCurrentSession()

  const { sourceId, loading: loadingSourceId, error: errorSourceId } = useSlugToSourceId(slug)

  const { data, loading, error } = useQuery(ReportCreatePageDocument, {
    variables: { id: sourceId ?? '', companyId: company.id },
    skip: !sourceId,
  })

  return (
    <>
      {!sourceId || loading || error || !data?.iris.factTable ? (
        <ResponsivePage.Body
          variant="fullscreen"
          loading={loading || loadingSourceId}
          error={error || errorSourceId}
        >
          &nbsp;
        </ResponsivePage.Body>
      ) : (
        <AiReportsMainContent sourceId={sourceId} datasource={data.iris.factTable} />
      )}
    </>
  )
}

export default AiReportsPage
